/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_CONTRACTS, GET_CONTRACTS } from 'src/actions/contractsActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const contractsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CONTRACTS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_CONTRACTS: {
      const { contracts, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = contracts;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default contractsReducer;
